import React, { createContext, Dispatch, SetStateAction, useContext, useState } from 'react';
import { Group } from '../services/Group';

interface CachedGroup {
  [key: number]: Group;
}

interface Props {
  cachedGroups: CachedGroup;
  children: React.ReactNode;
}

export type GroupContextType = {
  cachedGroups: CachedGroup;
  setCachedGroups: Dispatch<SetStateAction<CachedGroup>>;
};

const GroupContext = createContext<GroupContextType>({
  cachedGroups: {},
  setCachedGroups: () => console.warn('no Group provider'),
});

export function useGroupContext(): GroupContextType {
  return useContext(GroupContext);
}

export function GroupProvider({ children }: Props): JSX.Element {
  const [cachedGroups, setCachedGroups] = useState<CachedGroup>({});

  return <GroupContext.Provider value={{ cachedGroups, setCachedGroups }}>{children}</GroupContext.Provider>;
}
